import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const customerDistributionTypesSlice = createSlice({
  name: "customerDistributionTypes",
  initialState,
  reducers,
});

